import ContentAsset from '@components/common/ContentAsset';
import analytics from '@utils/analytics';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
const NFTInfoBox = (props) => {
    const { t } = useTranslation();
    useEffect(() => {
        const nftLink = document.querySelector('.nft-info-box a');
        nftLink.addEventListener('click', () => {
            analytics.nftBoxLink();
        });
    }, []);
    return (React.createElement("div", { className: "nft-info-box" },
        React.createElement(ContentAsset, { assetid: props.nftContentAsset.UUID, content: props.nftContentAsset.body })));
};
export default NFTInfoBox;
